import { render } from "./StepThree.vue?vue&type=template&id=145e3416&scoped=true&ts=true"
import script from "./StepThree.vue?vue&type=script&lang=ts"
export * from "./StepThree.vue?vue&type=script&lang=ts"

import "./StepThree.vue?vue&type=style&index=0&id=145e3416&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-145e3416"]])

export default __exports__